import { Box, BoxProps, convertHexToRGBA, Spacer, Text, TextProps } from '@jfs/ui-new'
import { MerchantTheme } from '../../../../data/models/Config'
import { formatAmount } from '../../../../utils'

interface SelectedEmiPlanInfoProps {
  amountPayable: any
  bankName: string
  theme: any
  emiData?: any
  changeEmiPlan?: any
}

export const SelectedEmiPlanInfo = ({
  amountPayable,
  bankName,
  theme,
  emiData,
  changeEmiPlan,
}: SelectedEmiPlanInfoProps) => {
  const selectedPlan = emiData
    ? `₹${formatAmount(emiData.value)} X ${emiData?.tenure} Months |  @${emiData?.interestRate}% p.a`
    : ''
  const styles = stylesFunc(theme)
  return (
    <Box {...styles.container}>
      <Box flexDirection={'row'} justifyContent="space-between">
        <Text {...styles.title}>Amount Payable:</Text>
        <Text {...styles.description}>₹{formatAmount(selectedPlan ? emiData?.totalAmount : amountPayable)}</Text>
      </Box>
      <Spacer size={12} />
      <Box flexDirection={'row'} justifyContent="space-between">
        <Text {...styles.title}>Card Selected:</Text>
        <Text {...styles.description}>{bankName}</Text>
      </Box>
      {selectedPlan && (
        <>
          <Spacer size={16} />
          <Box
            flexDirection={'row'}
            justifyContent="space-between"
            onPress={changeEmiPlan}
            testID="change-plan"
            underlayColor="TRANSPARENT">
            <Text {...styles.title}>EMI Plan Selected:</Text>
            <Text {...styles.selectedEmiPlan}>{selectedPlan}</Text>
          </Box>
        </>
      )}
    </Box>
  )
}

const stylesFunc = (theme: typeof MerchantTheme.properties) => ({
  container: {
    borderStyle: 'dashed',
    borderWidth: 1,
    p: 16,
    marginHorizontal: 18,
    borderRadius: 4,
    borderColor: convertHexToRGBA(theme.bodyTextColor, 10),
    backgroundColor: convertHexToRGBA(theme.bodyTextColor, 2),
  } as BoxProps,
  title: {
    fontSize: 12,
    fontFamily: 'jioType-light',
    color: convertHexToRGBA(theme.bodyTextColor, 90) as any,
  } as TextProps,
  description: {
    fontSize: 12,
    fontFamily: 'jioType-bold',
    color: theme.bodyTextColor as any,
  } as TextProps,
  selectedEmiPlan: {
    fontSize: 12,
    fontFamily: 'jioType-bold',
    color: theme.brandColor as any,
    textDecorationStyle: 'solid',
    textDecorationLine: 'underline',
  } as TextProps,
})
